import ParticipantServiceFamily, {IParticipantServiceFamily} from "@/model/ServiceFamily/ParticipantServiceFamily"

export interface IFoodServiceFamily extends IParticipantServiceFamily {

}

class FoodServiceFamily extends ParticipantServiceFamily implements IFoodServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}
export default FoodServiceFamily